/* src/app/shared/strava-item/strava-item.component.scss */
.stravaItem {
  width: 90vw;
  min-width: 90vw;
  max-width: 90vw;
  background-color: white;
  padding: 3vw;
  box-shadow: 0 0 2px 1px gray;
}
.itemDetails {
  z-index: 1;
  position: absolute;
  top: 3.5vw;
  left: 19vw;
  padding: 1vw 3vw 1vw;
  line-height: 5vw;
  color: black;
  width: -webkit-fill-available;
  font-size: 4vw;
}
.placeholder {
  min-width: 16vw;
  max-width: 16vw;
  max-height: 16vw;
  min-height: 16vw;
  background-color: lightgray;
  background-size: contain;
  background-image: url(/assets/images/logo.png);
  background-repeat: no-repeat;
  background-position: center center;
}
.boldTitle {
  color: black;
  font-weight: bold;
}
app-polyline-map {
  pointer-events: none;
}
/*# sourceMappingURL=strava-item.component.css.map */
